/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from 'react';

import classNames from 'classnames';
import Tooltip from '../../Tooltip';

import QuestionModal from '../../../modals/QuestionModal';
import ViewImageSectionModal from '../../../modals/ViewImageSectionModal';
import UploadDocumentsModal from '../../../modals/UploadDocumentsModal';

import classes from './styles.module.scss';
import audioPlaceholder from '../../../assets/images/section-menu/audio-placeholder.png';
import questionSection from '../../../assets/images/section-menu/question-section.png';
import noteIcon from '../../../assets/images/section-menu/notes.svg';
import useViewMeetingSectionLogic from '../../../hooks/useViewMeetingSectionLogic';
import { useMeetingViewStore } from '../../../store';
import { getDocumentIcon } from '../../../pages/CreateVideoNewPage/lib/getDocumentIcon';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';

export default function Section({
  section,
  index,
  isCurrent,
  videoRef,
  setIsPlaying,
  shouldReturnToFulscreen,
  setShouldReturnToFulscreen,
  fullscreenContainerRef,
  setIsSignUpPopupVisible,
  setCurrentSectionIndex,
  currentSectionIndex,
  preview,
  refetchMeeting,
  sectionsPageCount,
  sectionCount,
  miniVideoRef,
  currentSectionRef,
}) {
  const {
    isQuestionModalVisible,
    hideQuestionModal,
    switchToSection,
    isViewImageSectionModalVisible,
    hideViewImageSectionModal,
    shouldDisableQuestionModalAnimationOnEnter,
    shouldDisableQuestionModalAnimationOnExit,
    isUploadDocumentsModalVisible,
    hideUploadDocumentsModal,
  } = useViewMeetingSectionLogic({
    videoRef,
    section,
    isCurrent,
    setIsPlaying,
    shouldReturnToFulscreen,
    setShouldReturnToFulscreen,
    fullscreenContainerRef,
    setIsSignUpPopupVisible,
    setCurrentSectionIndex,
    currentSectionIndex,
    sectionsPageCount,
    sectionCount,
    miniVideoRef,
  });

  const isMobile = useCheckMobileScreen();

  const setCurrentQuestion = useMeetingViewStore(
    (state) => state.setCurrentQuestion
  );

  useEffect(() => {
    if (isCurrent && section.type === 'question') {
      setCurrentQuestion(section.Question);
    }
  }, [isCurrent, section, setCurrentQuestion]);

  let sectionContent = (
    <div className={classes.sectionContent}>
      {section.signedThumbnailS3FileKey ? (
        <img src={section.signedThumbnailS3FileKey} alt="Thumbnail" />
      ) : (
        <video src={section.signedS3Url} />
      )}
    </div>
  );

  if (section.type === 'assigned-section') {
    return null;
  }
  if (section.type === 'audio') {
    sectionContent = (
      <div className={classes.sectionContent}>
        <img src={audioPlaceholder} alt="Audio" />
      </div>
    );
  } else if (section.type === 'question') {
    sectionContent = (
      <div className={classes.sectionContent}>
        <img src={questionSection} alt="Question" />
      </div>
    );
  } else if (section.type === 'note') {
    sectionContent = (
      <div
        className={classNames(
          classes.sectionContent,
          classes.noteSectionContent
        )}
      >
        <img
          src={noteIcon}
          alt="Note"
          style={
            isMobile ? { objectFit: 'contain' } : { width: 100, height: 'auto' }
          }
        />
      </div>
    );
  } else if (section.type === 'image') {
    sectionContent = (
      <div className={classes.sectionContent}>
        <img src={section.SectionAttachments?.[0]?.signedS3Url} alt="" />
      </div>
    );
  } else if (section.type === 'document') {
    // Get the first document attachment's file name to determine the icon
    const firstAttachment = section.SectionAttachments?.[0];
    const documentIcon = getDocumentIcon(
      firstAttachment?.fileName || section.title || '',
      null // MIME type not available in this context
    );
    sectionContent = (
      <div className={classNames(classes.sectionContent, classes.document)}>
        <img src={documentIcon} alt="" />
      </div>
    );
  }

  return (
    <li
      className={classNames(classes.Section, {
        [classes.current]: isCurrent,
      })}
      onClick={() => switchToSection(index)}
      ref={isCurrent ? currentSectionRef : null}
    >
      {sectionContent}
      {isMobile ? (
        <div
          className={classNames(classes.title, {
            [classes.current]: isCurrent,
          })}
        >
          <span>{section.title}</span>
        </div>
      ) : (
        <div className={classes.titleContainer}>
          <Tooltip position="bottom" text={section.title}>
            <div className={classes.title}>
              <span>{section.title}</span>
            </div>
          </Tooltip>
        </div>
      )}
      {section.type === 'question' && (
        <QuestionModal
          show={isQuestionModalVisible}
          handleClose={hideQuestionModal}
          refetchMeeting={refetchMeeting}
          preview={preview}
          shouldDisableQuestionModalAnimationOnEnter={
            shouldDisableQuestionModalAnimationOnEnter
          }
          shouldDisableQuestionModalAnimationOnExit={
            shouldDisableQuestionModalAnimationOnExit
          }
        />
      )}
      {section.type === 'image' && (
        <ViewImageSectionModal
          show={isViewImageSectionModalVisible}
          handleClose={hideViewImageSectionModal}
          images={section.SectionAttachments}
          text={section.text}
        />
      )}
      {section.type === 'document' && (
        <UploadDocumentsModal
          show={isUploadDocumentsModalVisible}
          handleClose={hideUploadDocumentsModal}
          initialFiles={section.SectionAttachments}
          text={section.text}
          readOnly
        />
      )}
    </li>
  );
}
